var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentAdvice(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 2.667V0H.335v12h13.333V2.667H7.001Zm-4 8H1.668V9.333h1.334v1.334ZM3 8H1.668V6.667h1.334V8Zm0-2.667H1.668V4h1.334v1.333Zm0-2.666H1.668V1.333h1.334v1.334Zm2.667 8H4.334V9.333h1.333v1.334Zm0-2.667H4.334V6.667h1.333V8Zm0-2.667H4.334V4h1.333v1.333Zm0-2.666H4.334V1.333h1.333v1.334Zm6.667 8H7.001V9.333h1.333V8H7.001V6.667h1.333V5.333H7.001V4h5.333v6.667Zm-1.333-5.334H9.667v1.334h1.334V5.333ZM11 8H9.667v1.333h1.334V8Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentAdvice);
export default __webpack_public_path__ + "static/media/payment-advice.b78115c5fd55530243373af03673c443.svg";
export { ForwardRef as ReactComponent };